import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import $axios from './index';

export const getContacts = createAsyncThunk('contact/getAll', async ({ page = 1, limit = 20 } = {}) => {
  const res = await $axios.get(`/contact?page=${page}&limit=${limit}`);
  return res.data;
});

export const getNewsletterSubscribers = createAsyncThunk('newsletter/getAll', async ({ page = 1, limit = 20 } = {}) => {
  const res = await $axios.get(`/newsletter?page=${page}&limit=${limit}`);
  return res.data;
});

const contactNewsletterSlice = createSlice({
  name: 'contactNewsletter',
  initialState: {
    contacts: [],
    contactsTotal: 0,
    newsletter: [],
    newsletterTotal: 0,
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getContacts.pending, (state) => { state.loading = true; })
      .addCase(getContacts.fulfilled, (state, action) => {
        state.loading = false;
        state.contacts = action.payload?.data || [];
        state.contactsTotal = action.payload?.total ?? 0;
      })
      .addCase(getContacts.rejected, (state) => { state.loading = false; })
      .addCase(getNewsletterSubscribers.pending, (state) => { state.loading = true; })
      .addCase(getNewsletterSubscribers.fulfilled, (state, action) => {
        state.loading = false;
        state.newsletter = action.payload?.data || [];
        state.newsletterTotal = action.payload?.total ?? 0;
      })
      .addCase(getNewsletterSubscribers.rejected, (state) => { state.loading = false; });
  },
});

export default contactNewsletterSlice.reducer;
